export const TRACKING_EVENTS = {
  PAGE_VIEW: "page_view",
  SEARCH: "search",
  VIEW_SEARCH_RESULTS: "view_search_results",
  SELECT_ITEM: "select_item",
  VIEW_ITEM: "view_item",
  VIEW_ITEM_LIST: "view_item_list",
  ADD_TO_WISHLIST: "add_to_wishlist",
  VIEW_CART: "view_cart",
  ADD_TO_CART: "add_to_cart",
  PURCHASE: "purchase",
  VIDEO_START: "video_start",
  VIEW_PROMOTION: "view_promotion",
  SELECT_PROMOTION: "select_promotion",
  CLICK_COMMON: "click_common",
  VIDEO_PAUSE: "video_pause",
  VIDEO_COMPLETE: "video_complete",
} as const;

export const TRACKING_EVENT_TYPES = {
  HOME_PAGE_VIEW: "home-page-view",
  SEARCH: "search",
  DETAIL_PAGE_VIEW: "detail-page-view",
  CATEGORY_PAGE_VIEW: "category-page-view",
  SHOPPING_CART_PAGE_VIEW: "shopping-cart-page-view",
  ADD_TO_CART: "add-to-cart",
  PURCHASE_COMPLETE: "purchase-complete",
} as const;

export const QUANTITY_NUMBER = 1;

//負荷軽減に伴いpriceを2に固定化
export const TRACKING_PRICE = 2;

export const PAGE_TYPES = {
  FLOOR_TOP: "floor_top",
  SERVICE_TOP: "service_top",
  DETAIL: "detail",
  SEARCH: "search",
  LIST: "list",
  MYLIBRARY: "mylibrary",
} as const;
